module.exports = __webpack_public_path__ + "static/media/fan-table.cac94468.svg";